<template>
  <div class="mainBox wow animate__animated animate__fadeIn" style="margin-top: 2rem;">
    <!-- <div class="title" style="text-align: center">
      <div class="text1">分类1</div>
    </div> -->
    <!-- <el-input
      v-model="title"
      placeholder="请输入设备名称"
      autofocus
      :prefix-icon="Search"
      clearable
      size="large"
      width="20vw"
      style="margin-bottom: 1rem; width: 40vw"
      @keyup.enter="getList"
      @clear="getList"
    /> -->
    <div class="deviceList">
      <div class="deviceItem maria" v-for="(device, index) in deviceList" :key="index"
        @click="navTo('/product/deviceDetail', { id: device.id })">
        <OssImg class="deviceImg" :src="device.equipmentHeaderOssUrl" alt="" />
        <div class="deviceItemInfo">
          <div class="ellipsis">{{ device.equipmentTitle }}</div>
          <div class="ellipsis-multiline" style="-webkit-line-clamp: 2">
            {{ device.equipmentRemark }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="display_flex" style="margin: 2rem 0">
    <Pagenation v-bind="pageInfo" @changePage="changePage"></Pagenation>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import Pagenation from "@/components/Pagenation.vue";
import { WOW } from "wowjs";
import { useRoute } from "vue-router";
import { navTo } from "@/utils/util";
import ProductApi from "@/api/productApi";
import { Search } from "@element-plus/icons-vue";
import OssImg from "@/components/ossImg.vue";
const productApi = new ProductApi();
const route = useRoute();
const title = ref("");

const type = ref(0);
const deviceList = ref(12);
const pageInfo = ref({
  total: 0,
  pageSize: 12,
  pageNum: 1,
});

onMounted(() => {
  const wow = new WOW();
  wow.init();

  //获取页面参数
  type.value = route.query.type;
  getList();
});

const changePage = (page) => {
  console.log(page);
  pageInfo.value.pageNum = page;
  getList();
};

/**
 * 获取设备列表
 */
const getList = async () => {
  let res = await productApi.getMoreDevice({
    equipmentTitle: title.value,
    pageSize: pageInfo.value.pageSize,
    pageNum: pageInfo.value.pageNum,
  });
  if (res.code === 200) {
    deviceList.value = res.rows || [];
    pageInfo.total = deviceList.total;
  }
};
</script>

<style lang="scss" scoped>
.deviceList {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;

  .deviceItem {
    height: 25.25rem;
    border-radius: 1rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .deviceImg {
      width: 100%;
      height: 19.625rem;
      object-fit: contain;
      border-radius: 1rem 1rem 0 0;
    }

    .deviceItemInfo {
      width: 100%;
      flex: 1;
      padding: 1rem;
      box-sizing: border-box;
      text-align: justify;
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 500;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      >div:nth-child(2) {
        color: #888888;
      }
    }
  }
}

.moreBtn {
  width: 7.5625rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem auto 0;
  color: #ffffff;
  font-weight: 500;
  font-size: 1rem;
  background: #32A89E;
  border-radius: 0.5rem;
}
</style>
